import { render } from "./HeroiconsOutlineAcademicCap.vue?vue&type=template&id=6a5efcb9"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineAcademicCap.vue"]])

export default __exports__